import classNames from 'classnames'

import { EntityProfileHeaderTextButton } from '../EntityProfileHeaderTextButton'
import { EntityProfileHeaderTitleToggleButton } from '../EntityProfileHeaderTitleToggleButton'

import * as styles from './EntityProfileHeaderTitleActions.module.css'

function EntityProfileHeaderTitleActions({
  EditButton = EntityProfileHeaderTextButton,
  isArchived,
  isHeaderOpen,
  isHovered,
  isLoading,
  onClickEditTitleButton,
  onToggleHeader,
}) {
  const editButtonClassName = classNames(styles.editButton, {
    [styles.hovered]: isHovered,
  })

  return (
    <>
      {EditButton && !isArchived && !isLoading ? (
        <EditButton
          className={editButtonClassName}
          onClick={onClickEditTitleButton}
        />
      ) : null}
      <EntityProfileHeaderTitleToggleButton
        className={styles.titleItem}
        isOpen={isHeaderOpen}
        onClick={onToggleHeader}
      />
    </>
  )
}

export default EntityProfileHeaderTitleActions
